// import {useState,useEffect} from 'react'
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
// import { Eye } from 'lucide-react';
// import MarketplaceFeedDetailsModal from './MarketPlaceFeedDetailsModal';

// const BASE_URL = process.env.REACT_APP_BASE_URL;
// const MarketPlaceFeedOpportunities = () => {
//     const [type,setType] = useState("");
//     const [searchType,setSearchType] = useState("")
//     const [postId, setPostId] = useState(null);
//     const [open, setOpen] = useState(false);
//     const navigate = useNavigate()
//     const [feedOpportunities,setFeedOpportunities] = useState([]);
//       // console.log("The feed opportunities are:", feedOpportunities);
//       useEffect(()=>{
//            const fetchFeedOpportunities = async () =>{
//                   try {
//                     const response = await axios.get( `${BASE_URL}/marketplace/researcher/opportunity/`, {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem('access_token')}`,
//           'x-api-key': process.env.REACT_APP_X_API_KEY,
//         },
//       })
//       setFeedOpportunities(response.data);
//                   } catch (error) {
//                     console.error('Error fetching feed opportunities:', error);
//                   }
//            }
//            fetchFeedOpportunities()
//       },[])
//   return (
//     <>
//     <div className=" flex flex-col gap-4 flex-1 w-full">
//           <section className="
//     w-full
//     rounded-2xl border border-gray-200
//     bg-white
//     p-6
//     shadow-sm
//     transition-all duration-200
//     hover:shadow-md
//     hover:border-gray-300
//   ">
//   <div className="flex items-center gap-3 p-4 bg-[#e8f0f7] rounded-xl mb-6">
//   <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center flex-shrink-0">
//     <svg
//       className="w-5 h-5 text-[#0f6abf]"
//       fill="none"
//       stroke="currentColor"
//       viewBox="0 0 24 24"
//     >
//       <path
//         strokeLinecap="round"
//         strokeLinejoin="round"
//         strokeWidth="2"
//         d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
//       />
//     </svg>
//   </div>
//   <div className="flex-1 min-w-0">
//   <div className="flex items-center gap-2 flex-wrap">
//     <div className="text-sm font-semibold text-gray-900 break-words">
//       Researcher Opportunities
//     </div>
//     <div className="text-xs text-gray-500 break-words">
//       University ↔ Industry
//     </div>
//   </div>
// </div>

// </div>

// {
//   feedOpportunities.map((p, i) => (
//     <div
//       key={i}
//       className="bg-gray-50 border border-gray-200 rounded-xl p-4 mb-4 cursor-pointer hover:border-[#0f6abf] transition-colors"
//       onClick={() =>{
//       window.history.pushState({}, "", `/marketplace/feed/post/${p.id}?research_type=${p.research_type}&type=${p.publication_type}`);
//       setType(p?.publication_type)
//       setSearchType(p?.research_type) 
//       setPostId(p?.id)
//       setOpen(true)
//     }}
//     >
//       <div className="opp-header mb-4">
//                   {/* First Row: Badge and Profile */}
//                   <div className="flex items-center justify-between mb-3">
//                     {/* Left: Badge */}
//                     <div className="bg-[#e8f0f7] border border-[#0f6abf] text-[#0f6abf] text-xs font-semibold inline-block rounded-lg py-1 px-3">
//                      {p.university_data ? p?.university_data?.university_name :p?.profile_data?.name}
//                     </div>
//                     <div className="flex items-center gap-1 text-gray-600 text-sm">
//                       <Eye className="w-4 h-4" />
//                       <span>{p?.views}</span>
//                     </div>

//                     {/* Right: Profile Section */}
//                     <div
//                       className="flex items-center gap-2 cursor-pointer hover:opacity-80 transition-opacity">
//                      <img
//                            src={p?.university_data ? p?.university_data.university_logo : p?.profile_data?.profile_picture}
//                     alt="University"
//                           className="w-8 h-8 rounded-full object-cover border border-gray-300"
//                           onClick={(e)=>{
//                       e.stopPropagation()
//                        navigate(p?.university_data ? `/marketplace/university/${p?.university_data?.id}` : `/marketplace/independent_researcher/${p?.researcher}`)
//                     }}
//                         />
//                     </div>
//                   </div>
//  <div className="p-3 border border-gray-200  cursor-pointer transition-all duration-200 hover:shadow-md">

//   <div className="flex flex-wrap gap-2">
//     <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-gray-50 text-gray-700 border border-gray-200">
//       {p?.domain}
//     </span>
    
//     <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-blue-50 text-blue-600 border border-blue-100">
//       {p?.collaboration}
//     </span>
    
//     {/* <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-gray-50 text-gray-700 border border-gray-200">
//       {publication?.topic_of_interest}
//     </span> */}
    
//     <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-gray-50 text-gray-700 border border-gray-200">
//       {p?.maturity}
//     </span>
    
//     <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-green-50 text-green-600 border border-green-100">
//       {p?.visibility}
//     </span>
//   </div>
// </div>
//   <div className="w-full mt-4">
//                       {/* Media Preview */}
//               {p.publication_type === "image" && (
//                 <img
//                   src={p.file}
//                   alt={p.name}
//                   className="w-full h-48 object-cover"
//                 />
//               )}
//               {p.publication_type === "pdf" && (
//                 <iframe
//                   src={`${p.file}#toolbar=0`}
//                   title={p.name}
//                   className="w-full h-48"
//                 />
//               )}
//               {(p.publication_type === "doc" || p.type === "docx") && (
//                 <iframe
//                   src={`https://docs.google.com/gview?url=${encodeURIComponent(
//                     p.file
//                   )}&embedded=true`}
//                   title={p.name}
//                   className="w-full h-48"
//                 />
//               )}
//               {p.publication_type === "video" && (
//                 <video
//                   src={p.file}
//                   controls
//                   className="w-full h-48 object-cover"
//                 />
//               )}
//               {p.publication_type === "audio" && (
//                 <div className="w-full h-48 flex items-center justify-center bg-gray-100">
//                   <audio src={p.file} controls className="w-full px-4" />
//                 </div>
//               )}
//                 </div>
//                 </div>
//     </div>
//   ))
// }
//   </section>
//     </div>
//      <MarketplaceFeedDetailsModal id={postId} type={type} research_type={searchType} isOpen={open} onClose={() => setOpen(false)} />
//     </>
//   )
// }

// export default MarketPlaceFeedOpportunities
import { useState, useEffect, useRef, useCallback } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Eye } from 'lucide-react';
import MarketplaceFeedDetailsModal from './MarketPlaceFeedDetailsModal';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const MarketPlaceFeedOpportunities = () => {
  const navigate = useNavigate();

  const [feedOpportunities, setFeedOpportunities] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);

  const [type, setType] = useState("");
  const [searchType, setSearchType] = useState("");
  const [postId, setPostId] = useState(null);
  const [open, setOpen] = useState(false);

  const pageRef = useRef(1);
  const observer = useRef(null);

  // ---------------- FETCH ----------------
  const fetchOpportunities = async (pageNum, isNew = false) => {
    if (loading) return;

    try {
      setLoading(true);

      const response = await axios.get(
        `${BASE_URL}/marketplace/researcher/opportunity/?page=${pageNum}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
            'x-api-key': process.env.REACT_APP_X_API_KEY,
          },
        }
      );

      const newData = response.data.results || response.data;

      setFeedOpportunities((prev) =>
        isNew || pageNum === 1 ? newData : [...prev, ...newData]
      );

      setHasMore(!!response.data.next);
      pageRef.current = pageNum + 1;

    } catch (error) {
      console.error('Error fetching opportunities:', error);

      if (pageNum === 1) {
        setFeedOpportunities([]);
        setHasMore(false);
      }
    } finally {
      setLoading(false);
    }
  };

  // ---------------- INITIAL LOAD ----------------
  useEffect(() => {
    fetchOpportunities(1, true);
  }, []);

  // ---------------- INFINITE SCROLL ----------------
  const lastItemRef = useCallback(
    (node) => {
      if (loading) return;

      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting && hasMore && !loading) {
            fetchOpportunities(pageRef.current, false);
          }
        },
        {
          root: null,
          rootMargin: "200px",
          threshold: 0,
        }
      );

      if (node) observer.current.observe(node);
    },
    [loading, hasMore]
  );

  // cleanup
  useEffect(() => {
    return () => {
      if (observer.current) observer.current.disconnect();
    };
  }, []);

  // ---------------- UI ----------------
  return (
    <>
      <div className="flex flex-col gap-4 flex-1 w-full">

        <section className="w-full rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">

          <div className="flex items-center gap-3 p-4 bg-[#e8f0f7] rounded-xl mb-6">
            <div className="text-sm font-semibold text-gray-900">
              Researcher Opportunities
            </div>
          </div>

          {feedOpportunities.map((p, i) => {
            const isLast = i === feedOpportunities.length - 1;

            return (
              <div
                key={p.id}
                ref={isLast ? lastItemRef : null}
                className="bg-gray-50 border border-gray-200 rounded-xl p-4 mb-4 cursor-pointer hover:border-[#0f6abf]"
                onClick={() => {
                  window.history.pushState(
                    {},
                    "",
                    `/marketplace/feed/post/${p.id}?research_type=${p.research_type}&type=${p.publication_type}`
                  );

                  setType(p?.publication_type);
                  setSearchType(p?.research_type);
                  setPostId(p?.id);
                  setOpen(true);
                }}
              >

                {/* HEADER */}
                <div className="flex items-center justify-between mb-3">

                  <div className="bg-[#e8f0f7] text-[#0f6abf] text-xs font-semibold px-3 py-1 rounded-lg">
                    {p.university_data ? p?.university_data?.university_name : p?.profile_data?.name}
                  </div>

                  <div className="flex items-center gap-1 text-gray-600 text-sm">
                    <Eye className="w-4 h-4" />
                    <span>{p?.views}</span>
                  </div>

                  <img
                    src={
                      p?.university_data
                        ? p?.university_data.university_logo
                        : p?.profile_data?.profile_picture
                    }
                    className="w-8 h-8 rounded-full object-cover border"
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(
                        p?.university_data
                          ? `/marketplace/university/${p?.university_data?.id}`
                          : `/marketplace/independent_researcher/${p?.researcher}`
                      );
                    }}
                  />
                </div>

                {/* TAGS */}
                <div className="flex flex-wrap gap-2">
                  <span className="text-xs px-3 py-1 bg-gray-100 rounded-lg">{p?.domain}</span>
                  <span className="text-xs px-3 py-1 bg-blue-100 rounded-lg">{p?.collaboration}</span>
                  <span className="text-xs px-3 py-1 bg-gray-100 rounded-lg">{p?.maturity}</span>
                  <span className="text-xs px-3 py-1 bg-green-100 rounded-lg">{p?.visibility}</span>
                </div>

                {/* MEDIA */}
                <div className="mt-4">
                  {p.publication_type === "image" && (
                    <img src={p.file} className="w-full h-48 object-cover" />
                  )}

                  {p.publication_type === "video" && (
                    <video src={p.file} controls className="w-full h-48" />
                  )}

                  {p.publication_type === "audio" && (
                    <audio src={p.file} controls className="w-full" />
                  )}

                  {p.publication_type === "pdf" && (
                    <iframe src={`${p.file}#toolbar=0`} className="w-full h-48" />
                  )}
                </div>

              </div>
            );
          })}

          {/* LOADING STATE */}
      {loading && (
        <div className="flex justify-center py-6">
          <div className="text-gray-500 text-sm">Loading...</div>
        </div>
      )}

      {/* Load more indicator */}
      {!loading && hasMore && feedOpportunities.length > 0 && (
        <div className="flex justify-center py-6">
          <div className="text-gray-400 text-sm">Scroll to load more</div>
        </div>
      )}

      {/* End of list indicator */}
      {!loading && !hasMore && feedOpportunities.length > 0 && (
        <div className="flex justify-center py-6">
          <div className="text-gray-400 text-sm">No more opportunities</div>
        </div>
      )}


        </section>
      </div>

      <MarketplaceFeedDetailsModal
        id={postId}
        type={type}
        research_type={searchType}
        isOpen={open}
        onClose={() => setOpen(false)}
      />
    </>
  );
};

export default MarketPlaceFeedOpportunities;